import(/* webpackMode: "eager" */ "/vercel/path0/website/app/about/page.tsx");
